import { configureStore } from "@reduxjs/toolkit"
import { authReducer, usersReducer, categoriesReducer, coursesReducer, commonsReducer, subscriptionsReducer, assessmentsReducer, dashboardReducer, discountsReducer, courseStoreProductReducer } from "../../redux/reducers/index";

const reducer = {
    auth: authReducer,
    users: usersReducer,
    categories: categoriesReducer,
    courses: coursesReducer,
    commons: commonsReducer,
    subscriptions: subscriptionsReducer,
    assessments: assessmentsReducer,
    dashboard: dashboardReducer,
    discounts: discountsReducer,
    courseStoreProduct: courseStoreProductReducer,
};

const store = configureStore({
    reducer,
    devTools: process.env.NODE_ENV !== 'production'
});

export default store;